
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/dark-mode",
      function () {
        return require("private-next-pages/joy-ui/customization/dark-mode.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/dark-mode"])
      });
    }
  